import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=b0fd05ca&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"
import style0 from "./Comment.vue?vue&type=style&index=0&id=b0fd05ca&prod&scoped=true&lang=less"
import style1 from "./Comment.vue?vue&type=style&index=1&id=b0fd05ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fd05ca",
  null
  
)

export default component.exports